import { render, staticRenderFns } from "./LabelBatchEdit.vue?vue&type=template&id=3470c701&"
import script from "./LabelBatchEdit.vue?vue&type=script&lang=js&"
export * from "./LabelBatchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports